class ICaseHomeDeviceFinder extends HTMLElement {
  connectedCallback() {
    this.categorySelect = this.querySelector('[data-device-category]');
    this.brandSelect = this.querySelector('[data-device-brand]');
    this.seriesSelect = this.querySelector('[data-device-series]');
    this.modelSelect = this.querySelector('[data-device-model]');
    this.submit = this.querySelector('[data-device-submit]');

    if (!this.categorySelect || !this.brandSelect || !this.seriesSelect || !this.modelSelect || !this.submit) return;

    this.devices = Array.isArray(window.ICASE_DEVICE_FINDER_DATA)
      ? window.ICASE_DEVICE_FINDER_DATA.filter((device) => device.category && device.brand && device.series && device.model && device.url)
      : [];

    ['Phone', 'Tablet', 'Laptop', 'Smartwatch', 'Audio', 'Gaming']
      .filter((category) => this.devices.some((device) => device.category === category))
      .forEach((category) => this.categorySelect.add(new Option(category, category)));

    this.categorySelect.addEventListener('change', () => this.renderBrands());
    this.brandSelect.addEventListener('change', () => this.renderSeries());
    this.seriesSelect.addEventListener('change', () => this.renderModels());
    this.modelSelect.addEventListener('change', () => this.updateSubmit());
    this.submit.addEventListener('click', (event) => {
      if (this.submit.getAttribute('aria-disabled') === 'true') event.preventDefault();
    });
  }

  uniqueValues(field, predicate) {
    return [...new Set(this.devices.filter(predicate).map((device) => device[field]))];
  }

  resetSelect(select, label) {
    select.replaceChildren(new Option(label, ''));
    select.disabled = true;
  }

  renderBrands() {
    const category = this.categorySelect.value;
    this.resetSelect(this.brandSelect, 'Select a brand');
    this.uniqueValues('brand', (device) => device.category === category)
      .forEach((brand) => this.brandSelect.add(new Option(brand, brand)));
    this.brandSelect.disabled = !category;
    this.resetSelect(this.seriesSelect, 'Select a series');
    this.resetSelect(this.modelSelect, 'Select a model');
    this.updateSubmit();
  }

  renderSeries() {
    const category = this.categorySelect.value;
    const brand = this.brandSelect.value;
    this.resetSelect(this.seriesSelect, 'Select a series');
    const series = this.uniqueValues('series', (device) => device.category === category && device.brand === brand);
    series.forEach((value) => this.seriesSelect.add(new Option(value, value)));
    this.seriesSelect.disabled = !brand;
    this.resetSelect(this.modelSelect, 'Select a model');
    if (series.length === 1) {
      this.seriesSelect.value = series[0];
      this.renderModels();
    } else {
      this.updateSubmit();
    }
  }

  renderModels() {
    const category = this.categorySelect.value;
    const brand = this.brandSelect.value;
    const series = this.seriesSelect.value;
    this.resetSelect(this.modelSelect, 'Select a model');
    this.devices
      .filter((device) => device.category === category && device.brand === brand && device.series === series)
      .forEach((device) => this.modelSelect.add(new Option(device.model, device.url)));
    this.modelSelect.disabled = !series;
    this.updateSubmit();
  }

  updateSubmit() {
    const url = this.modelSelect.value;
    this.submit.href = url || '#';
    this.submit.setAttribute('aria-disabled', url ? 'false' : 'true');
  }
}

if (!customElements.get('icase-home-device-finder')) {
  customElements.define('icase-home-device-finder', ICaseHomeDeviceFinder);
}
